'use client';

// import { Button, Flexbox } from '@doc/ui-components';
// import Image from 'next/image';
// import { useTheme } from 'next-themes';
import { useEffect } from 'react';

export const ThemeToggle = () => {
	// const { resolvedTheme, setTheme } = useTheme();
	// const [mounted, setMounted] = useState(false);

	//TODO : Restore the theme toggle functionality when the theme will be managed properly.
	// localStorage.setItem('theme', 'light') - to be removed when the theme will be managed properly
	useEffect(() => localStorage.setItem('theme', 'light'), []);
	return null;
	// useEffect(() => setMounted(true), []);
	// if (!mounted) return null;

	// return (
	// 	<Button onClick={() => setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')} variant='text'>
	// 		<Flexbox alignContent='center' justify='center'>
	// 			<Image
	// 				alt='theme switcher'
	// 				className='absolute top-[50%] -translate-y-1/2'
	// 				height={80}
	// 				src={resolvedTheme === 'dark' ? '/abb_lightswitcher-dark.svg' : '/abb_lightswitcher-light.svg'}
	// 				width={52}
	// 			/>
	// 		</Flexbox>
	// 	</Button>
	// );
};
